import React from 'react';
import FusionCharts from 'fusioncharts';
import charts from 'fusioncharts/fusioncharts.charts';
import {dualYCombination, heatMapFusionChart, bubbleChartFusionCharts, disposeChart} from 'util/fusionChartManager';
import {connect} from 'react-redux';

charts(FusionCharts);

class App extends React.Component {
    devideCorrelationId = "device-correlation";
    valuePrioritizingId = "value-and-prioritizing";
    correlationHeatId = "correlation-heat";


    dispatchActionToHideLoader = () => {

        if (!this.state.partialLoaderStateDeviceCorrelationBreakdownSummary
            && !this.state.partialLoaderStateCorrelationHeatMap
            && !this.state.partialLoaderStateValueAndPrioritizationMapping) {
            this.props.hideLoader();
        }
    };

    render() {

        this.dispatchActionToHideLoader();

        return (
            <div id="correlation" className="contentOuter-wrapper">
                <div>
                    <div className="page-heading d-sm-flex justify-content-sm-between align-items-sm-center">
                        <h1 className="mb-0">Correlations</h1>
                    </div>
                </div>
                <div>
                    <div className="row ">
                        <div className="col-12 col-sm-12 col-md-12 col-lg-6 ">
                            <div className="jr-card set-background">
                                <div className="jr-card-header ">
                                    <h3 className="text-white">Device Correlation Breakdown Summary</h3>
                                </div>
                                <div className="jr-card-body contentInner-wrapper">
                                    <div id={this.devideCorrelationId}/>
                                </div>
                            </div>
                            <div className="jr-card set-background">
                                <div className="jr-card-header">
                                    <h3 className="text-white float-right text-nowrap">Implementation Cost</h3>
                                    <img className="float-right mr-3"
                                         src="../../../../assets/images/green_circle_3.png"/>
                                    <img className="float-right mr-2 pt-1"
                                         src="../../../../assets/images/green_circle_2.png"/>
                                    <img className="float-right mr-2 pt-2"
                                         src="../../../../assets/images/green_circle_1.png"/>
                                    <h3 className="text-white">Value and Prioritization Mapping</h3>
                                </div>
                                <div className="jr-card-body ">

                                    <div id={this.valuePrioritizingId}/>
                                </div>
                            </div>
                        </div>
                        <div className="col-12 col-sm-12 col-md-12 col-lg-6">
                            <div className="jr-card pb-4 set-background">
                                <div className="jr-card-header">
                                    <h3 className="text-white">Correlation Heat Map</h3>
                                </div>
                                <div className="jr-card-body pt-5">
                                    <div id={this.correlationHeatId}/>
                                </div>
                            </div>
                        </div>

                        <div className="col-12 col-sm-12 col-md-12 col-lg-12">
                            <div className="jr-card source-systems justify-content-center set-background">
                                <div className="jr-card-header">
                                    <h3 className="text-white">Source System Data Correlations</h3>
                                </div>
                                <div className="jr-card-body row source-systems justify-content-center">
                                    <div className="col-6 col-sm-3 col-lg">
                                        <img className="img-container" src="../../../../assets/images/container.png"/>
                                        <p className="center-the-text">UDS/DDE</p>
                                        <img className="blue-circle-position"
                                             src="../../../../assets/images/blue_circle.png"/>
                                        <p className="number-position">2</p>
                                        <p className="center-the-small-text">BI Reporting</p>
                                    </div>
                                    <div className="col-6 col-sm-3 col-lg">
                                        <img className="img-container" src="../../../../assets/images/container.png"/>
                                        <p className="center-the-text">Remedy</p>
                                        <img className="blue-circle-position"
                                             src="../../../../assets/images/blue_circle.png"/>
                                        <p className="number-position">13</p>
                                        <p className="center-the-small-text">Incidents</p>
                                    </div>
                                    <div className="col-6 col-sm-3 col-lg">
                                        <img className="img-container" src="../../../../assets/images/container.png"/>
                                        <p className="center-the-text">Netcool</p>
                                        <img className="blue-circle-position"
                                             src="../../../../assets/images/blue_circle.png"/>
                                        <p className="number-position">16</p>
                                        <p className="center-the-small-text">Network Alarms</p>
                                    </div>
                                    <div className="col-6 col-sm-3 col-lg">
                                        <img className="img-container" src="../../../../assets/images/container.png"/>
                                        <p className="center-the-text">Genesys</p>
                                        <img className="blue-circle-position"
                                             src="../../../../assets/images/blue_circle.png"/>
                                        <p className="number-position">9</p>
                                        <p className="center-the-small-text">Call Centre</p>
                                    </div>
                                    <div className="col-6 col-sm-3 col-lg">
                                        <img className="img-container" src="../../../../assets/images/container.png"/>
                                        <p className="center-the-text">Comptel</p>
                                        <img className="blue-circle-position"
                                             src="../../../../assets/images/blue_circle.png"/>
                                        <p className="number-position">5</p>
                                        <p className="center-the-small-text">Order Fulfilment</p>
                                    </div>
                                    <div className="col-6 col-sm-3 col-lg">
                                        <img className="img-container" src="../../../../assets/images/container.png"/>
                                        <p className="center-the-text">Maximo</p>
                                        <img className="blue-circle-position"
                                             src="../../../../assets/images/blue_circle.png"/>
                                        <p className="number-position">5</p>
                                        <p className="center-the-small-text">Workforce Mgtmt.</p>
                                    </div>
                                    <div className="col-6 col-sm-3 col-lg">
                                        <img className="img-container" src="../../../../assets/images/container.png"/>
                                        <p className="center-the-text">Quittiq</p>
                                        <img className="blue-circle-position"
                                             src="../../../../assets/images/blue_circle.png"/>
                                        <p className="number-position">12</p>
                                        <p className="center-the-small-text">Field Force</p>
                                    </div>
                                    <div className="col-6 col-sm-3 col-lg">
                                        <img className="img-container" src="../../../../assets/images/container.png"/>
                                        <p className="center-the-text">PNI/ELMS</p>
                                        <img className="blue-circle-position"
                                             src="../../../../assets/images/blue_circle.png"/>
                                        <p className="number-position">14</p>
                                        <p className="center-the-small-text">Inventory/Location</p>
                                    </div>
                                    <div className="col-6 col-sm-3 col-lg">
                                        <img className="img-container" src="../../../../assets/images/container.png"/>
                                        <p className="center-the-text">CRM</p>
                                        <img className="blue-circle-position"
                                             src="../../../../assets/images/blue_circle.png"/>
                                        <p className="number-position">22</p>
                                        <p className="center-the-small-text">Customer Profile</p>
                                    </div>
                                    <div/>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    constructor(props) {
        super(props);

        this.props.showLoader();

        this.state = {
            // Setting initial values for partial loader state for all charts to be rendered
            partialLoaderStateDeviceCorrelationBreakdownSummary: true,
            partialLoaderStateCorrelationHeatMap: true,
            partialLoaderStateValueAndPrioritizationMapping: true
        };
    }

    componentDidMount = () => {

        const self = this;

        // initializing device-correlation chart

        const deviceCorrelationCategories = [{
            category: [{
                label: 'BoM ForeCast',
            }, {
                label: 'Service Incident',
            }, {
                label: 'Network Fault',
            }, {
                label: 'PNI Data Error',
            }, {
                label: 'Security Breach',
            }, {
                label: 'Repeat Truck Roll',
            }, {
                label: 'Long MTTC',
            }, {
                label: 'Long MTTR',
            }, {
                label: 'SLA Breach',
            }],
        }];

        const deviceCorrelationDataset = [{
            seriesName: 'This Week',
            color: '#4fb1ec',
            data: [{
                value: '17',
            }, {
                value: '130',
            }, {
                value: '104',
            }, {
                value: '84',
            }, {
                value: '14',
            }, {
                value: '96',
            }, {
                value: '87',
            }, {
                value: '64',
            }, {
                value: '68',
            }],
        }, {
            seriesName: 'Last Week',
            parentYAxis: 'S',
            renderAs: 'line',
            showValues: '0',
            color: '#92d050',
            data: [{
                value: '34',
            }, {
                value: '80',
            }, {
                value: '60',
            }, {
                value: '84',
            }, {
                value: '14',
            }, {
                value: '60',
            }, {
                value: '40',
            }, {
                value: '25',
            }, {
                value: '68',
            }],
        }];

        dualYCombination('device-correlation', deviceCorrelationCategories, deviceCorrelationDataset)
            .then(() => {
                self.setState({
                    partialLoaderStateDeviceCorrelationBreakdownSummary: false
                });
            }, () => {
                self.setState({
                    partialLoaderStateDeviceCorrelationBreakdownSummary: false
                });
            });

        // initializing correlation-heat chart

        const dataset = [
            {
                data: [
                    {
                        rowid: 'BoM Forecast',
                        columnid: 'SLA Breach',
                        value: '1',
                        tllabel: 'Quad Core 2.5 GHz',
                        trlabel: 'OS : Android 4.4 Kitkat',
                    },
                    {
                        rowid: 'BoM Forecast',
                        columnid: 'Security Breach',
                        value: '7.3',
                        tllabel: '5.1 inch',
                        trlabel: 'AMOLED screen',
                    },
                    {
                        rowid: 'BoM Forecast',
                        columnid: 'Service Incident',
                        value: '9.3',
                        tllabel: '$600',
                    },
                    {
                        rowid: 'BoM Forecast',
                        columnid: 'Network Fault',
                        value: '9.7',
                        tllabel: '29 Hrs',
                        trlabel: 'Battery : 2800 MAH',
                    },
                    {
                        rowid: 'BoM Forecast',
                        columnid: 'PNI Data Error',
                        value: '8',
                        tllabel: '16 MP',
                        trlabel: 'Front Camera : 2.1 MP',
                    },
                    {
                        rowid: 'BoM Forecast',
                        columnid: 'Poor CSAT',
                        value: '9.2',
                        tllabel: 'Quad Core 2.3 GHz',
                        trlabel: 'OS : Android 4.4 Kitkat',
                    },
                    {
                        rowid: 'BoM Forecast',
                        columnid: 'Repeat Truck Poll',
                        value: '8.3',
                        tllabel: '5 inch',
                        trlabel: 'LCD screen',
                    },
                    {
                        rowid: 'BoM Forecast',
                        columnid: 'Long MTTC',
                        value: '7.3',
                        tllabel: '$600',
                    },
                    {
                        rowid: 'BoM Forecast',
                        columnid: 'Long MTTR',
                        value: '8.8',
                        tllabel: '20 Hrs',
                        trlabel: 'Battery : 2600 MAH',
                    },
                    {
                        rowid: 'BoM Forecast',
                        columnid: 'Long MTTR',
                        value: '8.7',
                        tllabel: '4 MP',
                        trlabel: 'Front Camera : 5 MP',
                    },
                    {
                        rowid: 'BoM Forecast',
                        columnid: 'Other',
                        value: '1',
                        tllabel: 'Dual Core',
                        trlabel: 'OS : iOS 7',
                    },
                    {
                        rowid: 'Temp',
                        columnid: 'SLA Breach',
                        value: '1',
                        tllabel: 'Quad Core 2.5 GHz',
                        trlabel: 'OS : Android 4.4 Kitkat',
                    },
                    {
                        rowid: 'Temp',
                        columnid: 'Security Breach',
                        value: '7.3',
                        tllabel: '5.1 inch',
                        trlabel: 'AMOLED screen',
                    },
                    {
                        rowid: 'Temp',
                        columnid: 'Service Incident',
                        value: '1',
                        tllabel: '$600',
                    },
                    {
                        rowid: 'Temp',
                        columnid: 'Network Fault',
                        value: '1',
                        tllabel: '29 Hrs',
                        trlabel: 'Battery : 2800 MAH',
                    },
                    {
                        rowid: 'Temp',
                        columnid: 'PNI Data Error',
                        value: '1',
                        tllabel: '16 MP',
                        trlabel: 'Front Camera : 2.1 MP',
                    },
                    {
                        rowid: 'Temp',
                        columnid: 'Poor CSAT',
                        value: '1',
                        tllabel: 'Quad Core 2.3 GHz',
                        trlabel: 'OS : Android 4.4 Kitkat',
                    },
                    {
                        rowid: 'Temp',
                        columnid: 'Repeat Truck Poll',
                        value: '1',
                        tllabel: '5 inch',
                        trlabel: 'LCD screen',
                    },
                    {
                        rowid: 'Temp',
                        columnid: 'Long MTTC',
                        value: '1',
                        tllabel: '$600',
                    },
                    {
                        rowid: 'Temp',
                        columnid: 'Long MTTR',
                        value: '1',
                        tllabel: '20 Hrs',
                        trlabel: 'Battery : 2600 MAH',
                    },
                    {
                        rowid: 'Temp',
                        columnid: 'Long MTTR',
                        value: '1',
                        tllabel: '4 MP',
                        trlabel: 'Front Camera : 5 MP',
                    },
                    {
                        rowid: 'Temp',
                        columnid: 'Other',
                        value: '1',
                        tllabel: 'Dual Core',
                        trlabel: 'OS : iOS 7',
                    },
                    {
                        rowid: 'Humidity',
                        columnid: 'SLA Breach',
                        value: '1',
                        tllabel: 'Quad Core 2.5 GHz',
                        trlabel: 'OS : Android 4.4 Kitkat',
                    },
                    {
                        rowid: 'Humidity',
                        columnid: 'Security Breach',
                        value: '7.3',
                        tllabel: '5.1 inch',
                        trlabel: 'AMOLED screen',
                    },
                    {
                        rowid: 'Humidity',
                        columnid: 'Service Incident',
                        value: '9.3',
                        tllabel: '$600',
                    },
                    {
                        rowid: 'Humidity',
                        columnid: 'Network Fault',
                        value: '9.7',
                        tllabel: '29 Hrs',
                        trlabel: 'Battery : 2800 MAH',
                    },
                    {
                        rowid: 'Humidity',
                        columnid: 'PNI Data Error',
                        value: '8',
                        tllabel: '16 MP',
                        trlabel: 'Front Camera : 2.1 MP',
                    },
                    {
                        rowid: 'Humidity',
                        columnid: 'Poor CSAT',
                        value: '9.2',
                        tllabel: 'Quad Core 2.3 GHz',
                        trlabel: 'OS : Android 4.4 Kitkat',
                    },
                    {
                        rowid: 'Humidity',
                        columnid: 'Repeat Truck Poll',
                        value: '8.3',
                        tllabel: '5 inch',
                        trlabel: 'LCD screen',
                    },
                    {
                        rowid: 'Humidity',
                        columnid: 'Long MTTC',
                        value: '7.3',
                        tllabel: '$600',
                    },
                    {
                        rowid: 'Humidity',
                        columnid: 'Long MTTR',
                        value: '8.8',
                        tllabel: '20 Hrs',
                        trlabel: 'Battery : 2600 MAH',
                    },
                    {
                        rowid: 'Humidity',
                        columnid: 'Long MTTR',
                        value: '8.7',
                        tllabel: '4 MP',
                        trlabel: 'Front Camera : 5 MP',
                    },
                    {
                        rowid: 'Humidity',
                        columnid: 'Other',
                        value: '1',
                        tllabel: 'Dual Core',
                        trlabel: 'OS : iOS 7',
                    },
                    {
                        rowid: 'Spacial Depth',
                        columnid: 'SLA Breach',
                        value: '1',
                        tllabel: 'Quad Core 2.5 GHz',
                        trlabel: 'OS : Android 4.4 Kitkat',
                    },
                    {
                        rowid: 'Spacial Depth',
                        columnid: 'Security Breach',
                        value: '7.3',
                        tllabel: '5.1 inch',
                        trlabel: 'AMOLED screen',
                    },
                    {
                        rowid: 'Spacial Depth',
                        columnid: 'Service Incident',
                        value: '9.3',
                        tllabel: '$600',
                    },
                    {
                        rowid: 'Spacial Depth',
                        columnid: 'Network Fault',
                        value: '9.7',
                        tllabel: '29 Hrs',
                        trlabel: 'Battery : 2800 MAH',
                    },
                    {
                        rowid: 'Spacial Depth',
                        columnid: 'PNI Data Error',
                        value: '8',
                        tllabel: '16 MP',
                        trlabel: 'Front Camera : 2.1 MP',
                    },
                    {
                        rowid: 'Spacial Depth',
                        columnid: 'Poor CSAT',
                        value: '9.2',
                        tllabel: 'Quad Core 2.3 GHz',
                        trlabel: 'OS : Android 4.4 Kitkat',
                    },
                    {
                        rowid: 'Spacial Depth',
                        columnid: 'Repeat Truck Poll',
                        value: '8.3',
                        tllabel: '5 inch',
                        trlabel: 'LCD screen',
                    },
                    {
                        rowid: 'Spacial Depth',
                        columnid: 'Long MTTC',
                        value: '7.3',
                        tllabel: '$600',
                    },
                    {
                        rowid: 'Spacial Depth',
                        columnid: 'Long MTTR',
                        value: '8.8',
                        tllabel: '20 Hrs',
                        trlabel: 'Battery : 2600 MAH',
                    },
                    {
                        rowid: 'Spacial Depth',
                        columnid: 'Long MTTR',
                        value: '8.7',
                        tllabel: '4 MP',
                        trlabel: 'Front Camera : 5 MP',
                    },
                    {
                        rowid: 'Spacial Depth',
                        columnid: 'Other',
                        value: '1',
                        tllabel: 'Dual Core',
                        trlabel: 'OS : iOS 7',
                    },
                    {
                        rowid: 'Power Leakage',
                        columnid: 'SLA Breach',
                        value: '1',
                        tllabel: 'Quad Core 2.5 GHz',
                        trlabel: 'OS : Android 4.4 Kitkat',
                    },
                    {
                        rowid: 'Power Leakage',
                        columnid: 'Security Breach',
                        value: '9.3',
                        tllabel: '5.1 inch',
                        trlabel: 'AMOLED screen',
                    },
                    {
                        rowid: 'Power Leakage',
                        columnid: 'Service Incident',
                        value: '9.3',
                        tllabel: '$600',
                    },
                    {
                        rowid: 'Power Leakage',
                        columnid: 'Network Fault',
                        value: '9.7',
                        tllabel: '29 Hrs',
                        trlabel: 'Battery : 2800 MAH',
                    },
                    {
                        rowid: 'Power Leakage',
                        columnid: 'PNI Data Error',
                        value: '8',
                        tllabel: '16 MP',
                        trlabel: 'Front Camera : 2.1 MP',
                    },
                    {
                        rowid: 'Power Leakage',
                        columnid: 'Poor CSAT',
                        value: '9.2',
                        tllabel: 'Quad Core 2.3 GHz',
                        trlabel: 'OS : Android 4.4 Kitkat',
                    },
                    {
                        rowid: 'Power Leakage',
                        columnid: 'Repeat Truck Poll',
                        value: '8.3',
                        tllabel: '5 inch',
                        trlabel: 'LCD screen',
                    },
                    {
                        rowid: 'Power Leakage',
                        columnid: 'Long MTTC',
                        value: '7.3',
                        tllabel: '$600',
                    },
                    {
                        rowid: 'Power Leakage',
                        columnid: 'Long MTTR',
                        value: '8.8',
                        tllabel: '20 Hrs',
                        trlabel: 'Battery : 2600 MAH',
                    },
                    {
                        rowid: 'Power Leakage',
                        columnid: 'Long MTTR',
                        value: '8.7',
                        tllabel: '4 MP',
                        trlabel: 'Front Camera : 5 MP',
                    },
                    {
                        rowid: 'Power Leakage',
                        columnid: 'Other',
                        value: '1',
                        tllabel: 'Dual Core',
                        trlabel: 'OS : iOS 7',
                    },
                    {
                        rowid: 'Gas Leakage',
                        columnid: 'SLA Breach',
                        value: '1',
                        tllabel: 'Quad Core 2.5 GHz',
                        trlabel: 'OS : Android 4.4 Kitkat',
                    },
                    {
                        rowid: 'Gas Leakage',
                        columnid: 'Security Breach',
                        value: '7.3',
                        tllabel: '5.1 inch',
                        trlabel: 'AMOLED screen',
                    },
                    {
                        rowid: 'Gas Leakage',
                        columnid: 'Service Incident',
                        value: '9.3',
                        tllabel: '$600',
                    },
                    {
                        rowid: 'Gas Leakage',
                        columnid: 'Network Fault',
                        value: '9.7',
                        tllabel: '29 Hrs',
                        trlabel: 'Battery : 2800 MAH',
                    },
                    {
                        rowid: 'Gas Leakage',
                        columnid: 'PNI Data Error',
                        value: '8',
                        tllabel: '16 MP',
                        trlabel: 'Front Camera : 2.1 MP',
                    },
                    {
                        rowid: 'Gas Leakage',
                        columnid: 'Poor CSAT',
                        value: '9.2',
                        tllabel: 'Quad Core 2.3 GHz',
                        trlabel: 'OS : Android 4.4 Kitkat',
                    },
                    {
                        rowid: 'Gas Leakage',
                        columnid: 'Repeat Truck Poll',
                        value: '8.3',
                        tllabel: '5 inch',
                        trlabel: 'LCD screen',
                    },
                    {
                        rowid: 'Gas Leakage',
                        columnid: 'Long MTTC',
                        value: '7.3',
                        tllabel: '$600',
                    },
                    {
                        rowid: 'Gas Leakage',
                        columnid: 'Long MTTR',
                        value: '8.8',
                        tllabel: '20 Hrs',
                        trlabel: 'Battery : 2600 MAH',
                    },
                    {
                        rowid: 'Gas Leakage',
                        columnid: 'Long MTTR',
                        value: '8.7',
                        tllabel: '4 MP',
                        trlabel: 'Front Camera : 5 MP',
                    },
                    {
                        rowid: 'Gas Leakage',
                        columnid: 'Other',
                        value: '1',
                        tllabel: 'Dual Core',
                        trlabel: 'OS : iOS 7',
                    },
                    {
                        rowid: 'Movement',
                        columnid: 'SLA Breach',
                        value: '1',
                        tllabel: 'Quad Core 2.5 GHz',
                        trlabel: 'OS : Android 4.4 Kitkat',
                    },
                    {
                        rowid: 'Movement',
                        columnid: 'Security Breach',
                        value: '7.3',
                        tllabel: '5.1 inch',
                        trlabel: 'AMOLED screen',
                    },
                    {
                        rowid: 'Movement',
                        columnid: 'Service Incident',
                        value: '9.3',
                        tllabel: '$600',
                    },
                    {
                        rowid: 'Movement',
                        columnid: 'Network Fault',
                        value: '9.7',
                        tllabel: '29 Hrs',
                        trlabel: 'Battery : 2800 MAH',
                    },
                    {
                        rowid: 'Movement',
                        columnid: 'PNI Data Error',
                        value: '8',
                        tllabel: '16 MP',
                        trlabel: 'Front Camera : 2.1 MP',
                    },
                    {
                        rowid: 'Movement',
                        columnid: 'Poor CSAT',
                        value: '9.2',
                        tllabel: 'Quad Core 2.3 GHz',
                        trlabel: 'OS : Android 4.4 Kitkat',
                    },
                    {
                        rowid: 'Movement',
                        columnid: 'Repeat Truck Poll',
                        value: '8.3',
                        tllabel: '5 inch',
                        trlabel: 'LCD screen',
                    },
                    {
                        rowid: 'Movement',
                        columnid: 'Long MTTC',
                        value: '7.3',
                        tllabel: '$600',
                    },
                    {
                        rowid: 'Movement',
                        columnid: 'Long MTTR',
                        value: '8.8',
                        tllabel: '20 Hrs',
                        trlabel: 'Battery : 2600 MAH',
                    },
                    {
                        rowid: 'Movement',
                        columnid: 'Long MTTR',
                        value: '8.7',
                        tllabel: '4 MP',
                        trlabel: 'Front Camera : 5 MP',
                    },
                    {
                        rowid: 'Movement',
                        columnid: 'Other',
                        value: '1',
                        tllabel: 'Dual Core',
                        trlabel: 'OS : iOS 7',
                    },
                    {
                        rowid: 'Intrusion',
                        columnid: 'SLA Breach',
                        value: '1',
                        tllabel: 'Quad Core 2.5 GHz',
                        trlabel: 'OS : Android 4.4 Kitkat',
                    },
                    {
                        rowid: 'Intrusion',
                        columnid: 'Security Breach',
                        value: '7.3',
                        tllabel: '5.1 inch',
                        trlabel: 'AMOLED screen',
                    },
                    {
                        rowid: 'Intrusion',
                        columnid: 'Service Incident',
                        value: '9.3',
                        tllabel: '$600',
                    },
                    {
                        rowid: 'Intrusion',
                        columnid: 'Network Fault',
                        value: '9.7',
                        tllabel: '29 Hrs',
                        trlabel: 'Battery : 2800 MAH',
                    },
                    {
                        rowid: 'Intrusion',
                        columnid: 'PNI Data Error',
                        value: '8',
                        tllabel: '16 MP',
                        trlabel: 'Front Camera : 2.1 MP',
                    },
                    {
                        rowid: 'Intrusion',
                        columnid: 'Poor CSAT',
                        value: '9.2',
                        tllabel: 'Quad Core 2.3 GHz',
                        trlabel: 'OS : Android 4.4 Kitkat',
                    },
                    {
                        rowid: 'Intrusion',
                        columnid: 'Repeat Truck Poll',
                        value: '8.3',
                        tllabel: '5 inch',
                        trlabel: 'LCD screen',
                    },
                    {
                        rowid: 'Intrusion',
                        columnid: 'Long MTTC',
                        value: '7.3',
                        tllabel: '$600',
                    },
                    {
                        rowid: 'Intrusion',
                        columnid: 'Long MTTR',
                        value: '8.8',
                        tllabel: '20 Hrs',
                        trlabel: 'Battery : 2600 MAH',
                    },
                    {
                        rowid: 'Intrusion',
                        columnid: 'Long MTTR',
                        value: '8.7',
                        tllabel: '4 MP',
                        trlabel: 'Front Camera : 5 MP',
                    },
                    {
                        rowid: 'Intrusion',
                        columnid: 'Other',
                        value: '1',
                        tllabel: 'Dual Core',
                        trlabel: 'OS : iOS 7',
                    },
                    {
                        rowid: 'Battery Life',
                        columnid: 'SLA Breach',
                        value: '1',
                        tllabel: 'Quad Core 2.5 GHz',
                        trlabel: 'OS : Android 4.4 Kitkat',
                    },
                    {
                        rowid: 'Battery Life',
                        columnid: 'Security Breach',
                        value: '7.3',
                        tllabel: '5.1 inch',
                        trlabel: 'AMOLED screen',
                    },
                    {
                        rowid: 'Battery Life',
                        columnid: 'Service Incident',
                        value: '9.3',
                        tllabel: '$600',
                    },
                    {
                        rowid: 'Battery Life',
                        columnid: 'Network Fault',
                        value: '9.7',
                        tllabel: '29 Hrs',
                        trlabel: 'Battery : 2800 MAH',
                    },
                    {
                        rowid: 'Battery Life',
                        columnid: 'PNI Data Error',
                        value: '8',
                        tllabel: '16 MP',
                        trlabel: 'Front Camera : 2.1 MP',
                    },
                    {
                        rowid: 'Battery Life',
                        columnid: 'Poor CSAT',
                        value: '9.2',
                        tllabel: 'Quad Core 2.3 GHz',
                        trlabel: 'OS : Android 4.4 Kitkat',
                    },
                    {
                        rowid: 'Battery Life',
                        columnid: 'Repeat Truck Poll',
                        value: '8.3',
                        tllabel: '5 inch',
                        trlabel: 'LCD screen',
                    },
                    {
                        rowid: 'Battery Life',
                        columnid: 'Long MTTC',
                        value: '7.3',
                        tllabel: '$600',
                    },
                    {
                        rowid: 'Battery Life',
                        columnid: 'Long MTTR',
                        value: '8.8',
                        tllabel: '20 Hrs',
                        trlabel: 'Battery : 2600 MAH',
                    },
                    {
                        rowid: 'Battery Life',
                        columnid: 'Long MTTR',
                        value: '8.7',
                        tllabel: '4 MP',
                        trlabel: 'Front Camera : 5 MP',
                    },
                    {
                        rowid: 'Battery Life',
                        columnid: 'Other',
                        value: '1',
                        tllabel: 'Dual Core',
                        trlabel: 'OS : iOS 7',
                    },
                    {
                        rowid: 'Other',
                        columnid: 'SLA Breach',
                        value: '1',
                        tllabel: 'Quad Core 2.5 GHz',
                        trlabel: 'OS : Android 4.4 Kitkat',
                    },
                    {
                        rowid: 'Other',
                        columnid: 'Security Breach',
                        value: '9.3',
                        tllabel: '5.1 inch',
                        trlabel: 'AMOLED screen',
                    },
                    {
                        rowid: 'Other',
                        columnid: 'Service Incident',
                        value: '9.3',
                        tllabel: '$600',
                    },
                    {
                        rowid: 'Other',
                        columnid: 'Network Fault',
                        value: '9.7',
                        tllabel: '29 Hrs',
                        trlabel: 'Battery : 2800 MAH',
                    },
                    {
                        rowid: 'Other',
                        columnid: 'PNI Data Error',
                        value: '8',
                        tllabel: '16 MP',
                        trlabel: 'Front Camera : 2.1 MP',
                    },
                    {
                        rowid: 'Other',
                        columnid: 'Poor CSAT',
                        value: '9.2',
                        tllabel: 'Quad Core 2.3 GHz',
                        trlabel: 'OS : Android 4.4 Kitkat',
                    },
                    {
                        rowid: 'Other',
                        columnid: 'Repeat Truck Poll',
                        value: '8.3',
                        tllabel: '5 inch',
                        trlabel: 'LCD screen',
                    },
                    {
                        rowid: 'Other',
                        columnid: 'Long MTTC',
                        value: '7.3',
                        tllabel: '$600',
                    },
                    {
                        rowid: 'Other',
                        columnid: 'Long MTTR',
                        value: '8.8',
                        tllabel: '20 Hrs',
                        trlabel: 'Battery : 2600 MAH',
                    },
                    {
                        rowid: 'Other',
                        columnid: 'Long MTTR',
                        value: '8.7',
                        tllabel: '4 MP',
                        trlabel: 'Front Camera : 5 MP',
                    },
                    {
                        rowid: 'Other',
                        columnid: 'Other',
                        value: '1',
                        tllabel: 'Dual Core',
                        trlabel: 'OS : iOS 7',
                    },

                ],
            },
        ];

        heatMapFusionChart('correlation-heat', dataset)
            .then(() => {
                self.setState({
                    partialLoaderStateCorrelationHeatMap: false
                });
            });

        // initializing value-and-prioritizing

        bubbleChartFusionCharts('value-and-prioritizing')
            .then(() => {
                self.setState({
                    partialLoaderStateValueAndPrioritizationMapping: false
                });
            });
    };
    componentWillUnmount() {

        disposeChart(this.devideCorrelationId);
        disposeChart(this.valuePrioritizingId);
        disposeChart(this.correlationHeatId);

    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        showLoader: () => {
            dispatch({type: 'SHOW_OVERALL_APP_LOADER'});
        },
        hideLoader: () => {
            dispatch({
                type: 'HIDE_OVERALL_APP_LOADER'
            });
        }
    }
};

export default connect(null, mapDispatchToProps)(App);



// WEBPACK FOOTER //
// ./app/routes/correlations/index.js